import React from 'react';
import BundleDisplay from './BundleDisplay/BundleDisplay';
import OutfitComponent from './OutfitComponent/OutfitComponent';
import ProductDisplay from './ProductDisplay/ProductDisplay';
import ProductItemAttrDisplay from './ProductItemAttrDisplay/ProductItemAttrDisplay';
import ProductItemDisplay from './ProductItemDisplay/ProductItemDisplay';
import QuickViewDisplay from './QuickViewDisplay/QuickViewDisplay';
import NotAvailable from './NotAvailable/NotAvailable';
import ProductDisplayChanel from './ProductDisplayChanel/ProductDisplayChanel';
// import ProductDisplayEcard from './ProductDisplayEcard/AsyncProductDisplayEcard';
import ProductDisplayEcard from './ProductDisplayEcard/ProductDisplayEcard';
import BundleDisplayChanel from './BundleDisplayChanel/BundleDisplayChanel';
import ProductItemDisplayChanel from './ProductItemDisplayChanel/ProductItemDisplayChanel';
import QuickViewNotAvailable from './QuickViewNotAvailable/QuickViewNotAvailable';
import BadCatentryId from './BadCatentryId/BadCatentryId';
import ProductDetailHelmet from '../../../Shared/Content/ProductDetail/ProductDetailHelmet/ProductDetailHelmet';
import SharedProductDetail from '../../../Shared/Content/ProductDetail/ProductDetail';
import LoadingSpinner from '../../../../UI/LoadingSpinner/LoadingSpinner';
import { OldProduct } from './OldProduct/OldProduct';
import QuickViewOldProduct from './QuickViewOldProduct/QuickViewOldProduct';
import { QuickViewError } from './QuickViewError/QuickViewError';
import './Styles/product-main.scss';

export class ProductDetail extends SharedProductDetail {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
    };
  }

  render() {
    var contentData = this.props.contentData;
    if (this.props.quickViewData) {
      contentData = this.props.quickViewData.contentData;
    }
    var productLayout = contentData.productLayout || 'Loading';
    //if(contentData.unavailableMessage && productLayout.indexOf('QuickView') == -1){
    //	productLayout = 'OldProduct';
    //	if(!contentData.fullImage){
    //		productLayout = 'NotAvailable';
    //	}
    //}
    if (contentData.unavailableMessage && productLayout.indexOf('QuickView' == -1) && !contentData.fullImage) {
      productLayout = 'NotAvailable';
    }

    if (contentData.unavailableMessage && productLayout.indexOf('QuickView') > -1) {
      productLayout = 'QuickViewOldProduct';
      if (!contentData.fullImage) {
        productLayout = 'QuickViewNotAvailable';
      }
    }

    return (
      <section data-layout={productLayout}>
        {
          {
            ProductDisplay: (
              <ProductDisplay
                currentAttributeState={this.state.currentAttributeState}
                changeMainImage={this.changeMainImage}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></ProductDisplay>
            ),
            ProductDisplayChanel: (
              <ProductDisplayChanel
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></ProductDisplayChanel>
            ),
            BundleDisplay: (
              <BundleDisplay
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></BundleDisplay>
            ),
            BundleDisplayChanel: (
              <BundleDisplayChanel
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></BundleDisplayChanel>
            ),
            OutfitDisplay: (
              <BundleDisplay
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></BundleDisplay>
            ),
            OutfitComponent: (
              <OutfitComponent
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                parentPersonalization={this.props.parentPersonalization}
                parentProductLayout={this.props.parentProductLayout}
                forceBundleRender={this.passedFunctions.forceBundleRender}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></OutfitComponent>
            ),
            ProductItemAttrDisplay: (
              <ProductItemAttrDisplay
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></ProductItemAttrDisplay>
            ),
            ProductItemDisplay: (
              <ProductItemDisplay
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></ProductItemDisplay>
            ),
            ProductItemDisplayChanel: (
              <ProductItemDisplayChanel
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></ProductItemDisplayChanel>
            ),
            ProductDisplayEcard: (
              <ProductDisplayEcard
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></ProductDisplayEcard>
            ),
            QuickViewDisplay: (
              <QuickViewDisplay
                currentAttributeState={this.state.currentAttributeState}
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.state.altClicked}
              ></QuickViewDisplay>
            ),
            QuickViewNotAvailable: (
              <QuickViewNotAvailable
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></QuickViewNotAvailable>
            ),
            QuickViewError: (
              <QuickViewError
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></QuickViewError>
            ),
            NotAvailable: (
              <NotAvailable
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></NotAvailable>
            ),
            OldProduct: (
              <OldProduct
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></OldProduct>
            ),
            QuickViewOldProduct: (
              <QuickViewOldProduct
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></QuickViewOldProduct>
            ),
            BadCatentryId: (
              <BadCatentryId
                contentData={contentData}
                passedFunctions={this.passedFunctions()}
                passedAppFunctions={this.props.passedAppFunctions}
              ></BadCatentryId>
            ),
          }[productLayout]
        }
        {productLayout == 'Loading' ? (
          <LoadingSpinner passedAppFunctions={this.props.passedAppFunctions} />
        ) : productLayout == 'NotAvailable' || productLayout == 'QuickViewNotAvailable' ? (
          ''
        ) : (
          <ProductDetailHelmet contentData={contentData} passedAppFunctions={this.props.passedAppFunctions} />
        )}
      </section>
    );
  }
}

export default ProductDetail;
